export default "__VITE_ASSET__ymhVZKlr__"